// import hdWallet from 'wallet-address-validator';
// import WAValidator from "multicoin-address-validator";

import { isProd } from "config";

function validateUSDTTRONAddress(address: string) {
  const regEx = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}

function validateXRPAddress(address: string) {
  const regEx = /^r[1-9A-HJ-NP-Za-km-z]{25,34}$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}

function validateXRPAddressWithTag(address: string) {
  const regEx = /^r[1-9A-HJ-NP-Za-km-z]{25,34}(\?dt=[0-9]+)?$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}

function validateXLMAddress(address: string) {
  const regEx = /^[G|T][A-Z0-9]{55}$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}

function validateXLMAddressWithMemo(address: string) {
  const regEx = /^[G|T][A-Z0-9]{55}(\?dm=[0-9]+)?$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}

function validateBTCAddress(address: string) {
  const regEx = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}
function validateTBTCAddress(address: string) {
  const regEx = /^(bc1|[13][a-km-zA-HJ-NP-Z1-9]{25,39}|2[a-km-zA-HJ-NP-Z1-9]{25,39})$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}

function validateETHAddress(address: string) {
  const regEx = /^0x[a-fA-F0-9]{40}$/;

  if (regEx.test(address)) {
    return true;
  } else {
    return false;
  }
}

function validateLiskAddress(address: string) {
  const regEx = /^0x[a-fA-F0-9]{40}$/;
  return regEx.test(address);
}

export const isValidCryptoAddress = ({
  address,
  coin,
  network,
  tagNumber,
  memo,
}: {
  address: string;
  coin: string;
  network?: string;
  memo?: string;
  tagNumber?: string;
}): boolean => {
  try {
    const validator = (window as any).WAValidator;

    if (!validator) return false;
    // TODO: validate tron address
    if (coin === "usdt-tron" || network === "tron") {
      return validateUSDTTRONAddress(address);
    }
    if (coin === "xrp") {
      if (!tagNumber) return validateXRPAddress(address);
      return validateXRPAddressWithTag(`${address}?dt=${tagNumber}`);
    }
    if (coin === "xlm") {
      if (!memo) return validateXLMAddress(address);
      return validateXLMAddressWithMemo(`${address}?dm=${memo}`);
    }
    if (coin === "btc" || coin === "tbtc") {
      if (isProd) return validateBTCAddress(address);
      return validateTBTCAddress(address);
    }
    if (coin === "btc" || coin === "tbtc") {
      if (isProd) return validateBTCAddress(address);
      return validateTBTCAddress(address);
    }

    if (coin === "lisk") {
      return validateLiskAddress(address);
    }

    if (coin === "eth" || coin === "teth") {
    }

    if (
      coin === "eth" ||
      coin === "teth" ||
      coin === "usdt" ||
      coin === "usdc" ||
      coin === "pyusd" ||
      coin === "celo" ||
      coin === "cusd" ||
      coin === "ceur" ||
      coin === "matic" ||
      coin === "usdt-matic" ||
      coin === "usdc-matic" ||
      coin === 'lisk'
    ) {
      return validateETHAddress(address);
    }

    const isValid = validator.validate(address, String(coin).toUpperCase(), !isProd ? "testnet" : "prod");
    return isValid;
  } catch (err) {
    console.error("isValidCryptoAddress", err);
    return false;
  }
};

// export const isValidCryptoAddress = (address: string, coin: string): boolean => {
//   // const utils = hdWallet;

//   try {
//     let valid: boolean;

//     if (coin === "usdt-tron" || coin === "trx") {
//       // const isValidTxAddress = utils.validateAddress(address);
//       // return isValidTxAddress;
//       return true;
//     }
//     if (
//       coin === "eth" ||
//       coin === "teth" ||
//       coin === "usdt" ||
//       coin === "celo" ||
//       coin === "cusd" ||
//       coin === "matic" ||
//       coin === "usdt-matic" ||
//       coin === "usdc-matic"
//     ) {
//       valid = WAValidator.validate(address, "eth", !isProd ? "testnet" : "prod");
//       return valid;
//     }
//     if (coin === "btc" || coin === "tbtc") {
//       valid = WAValidator.validate(address, "btc", !isProd ? "testnet" : "prod");
//       return valid;
//     }
//     valid = WAValidator.validate(address, coin, !isProd ? "testnet" : "prod");
//     return valid;
//   } catch (e: any | Error | unknown) {
//     return e;
//   }
// };
